import React, { useRef, ChangeEvent, useEffect, useState } from 'react';
import OSS from 'ali-oss';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import { getToken, getCdnAuthNUrl } from '../../api/pile-apply';
import Toast from '@xpeng/rc-toast';
import FullLoading from '../../components/full-loading';
import 'react-photo-view/dist/react-photo-view.css';
import './index.less';

export interface FileDto {
  fileName?: string;
  fileOssPath?: string;
  url?: string;
}

interface UpdateImgProps {
  values: FileDto[];
  onChange: (urls: FileDto[]) => any;
  businessType?: string;
}

export default function UpdateImg(props: UpdateImgProps) {
  const { values, onChange, businessType } = props;
  const [loading, setLoading] = useState<boolean>(false);
  const inputEl = useRef<HTMLInputElement>(null);

  const getOssClient = (file: any) => {
    return new Promise((resolve, reject) => {
      getToken({ pathType: 3, fileName: file.name, businessType })
        .then((result: any) => {
          const client: any = new OSS({
            accessKeyId: result.accessKeyId,
            accessKeySecret: result.accessKeySecret,
            stsToken: result.securityToken || result.stsToken,
            region: result.region,
            bucket: result.bucket
          });
          Object.assign(client, {
            endpoint: result.endpoint,
            protocol: result.protocol || 'https',
            pathPrefix: result.pathPrefix,
            fileName: result.fileName,
          });
          resolve(client);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  };

  const ossUploadFile = async (option: any) => {
    return getOssClient(option).then((client: any) => {
      const file = option;
      const fileName = client.fileName;
      return client.multipartUpload(
        client.pathPrefix + '/' + fileName,
        file
      ).then(async (res: any) => {
        if (res?.res?.status !== 200) {
          throw new Error(`上传失败: ${res?.res?.status}`);
        }
        const urlList = await getCdnAuthNUrl({
          pathPrefix: client.pathPrefix,
          fileNameList: [fileName],
          businessType: businessType as string,
          encryptFlag: 0,
        });
        const authNUrl = urlList?.find(item => item.fileName === fileName)?.authNUrl || '';
        return {
          filePath: client.pathPrefix,
          fileName,
          url: authNUrl,
        };
      });
    });
  };

  const beforeUploadImgTypeLimit = (file: File | File[]): boolean => {
    if (Array.isArray(file)) {
      file = file[0];
    }
    const fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
    if (['png', 'jpeg', 'jpg', 'bmp'].includes(fileExtension)) {
      if (file.size > 10240 * 1024) {
        Toast.show('图片大小不能超过10M~');
        return false;
      }
      return true;
    }
    Toast.show('暂不支持该文件格式');
    return false;
  };

  const changeUrl = async (event: ChangeEvent) => {
    const el = event.target as HTMLInputElement;
    const files = [...((el && el.files) || [])];
    setLoading(true);
    try {
      const res = (await Promise.all(
        files.map((file: File) =>
          new Promise((resolve, reject) => {
            if (!beforeUploadImgTypeLimit(file)) {
              reject(false);
              return;
            }
            ossUploadFile(file)
              .then(updateRet => {
                resolve({
                  fileName: updateRet.fileName,
                  fileOssPath: updateRet.filePath,
                  url: updateRet.url,
                });
              })
              .catch(reject);
          })
        )
      )) as FileDto[];

      onChange([...values, ...res]);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleClick = () => {
    inputEl.current && inputEl.current.click();
  };

  const handeClickRemove = (index: number) => {
    onChange(values.filter((_, i) => i !== index));
  };

  useEffect(() => {
    if (loading) {
      FullLoading.show({ text: '上传中' });
    } else {
      FullLoading.hide();
    }
  }, [loading]);

  return (
    <div>
      <input
        ref={inputEl}
        accept="image/jpeg,image/jpg,image/png"
        style={{ display: 'none' }}
        type="file"
        multiple
        onChange={changeUrl}
        onClick={(event: any) => {
          if (event.target) {
            event.target.value = null;
          }
        }}
      />
      <PhotoProvider>
        <div className="img-list">
          {values.map((item, index) => (
            <div key={item.url} className="img-wrap">
              <div onClick={() => handeClickRemove(index)} className="delete">
                ×
              </div>
              <PhotoView src={item.url}>
                <img className="img" src={item.url} alt="" />
              </PhotoView>
            </div>
          ))}
          <button onClick={handleClick} className="add">
            +
          </button>
        </div>
      </PhotoProvider>
    </div>
  );
}
